import React, { FC } from 'react';
import parse, { DOMNode, Element } from 'html-react-parser';
import { IEntireArticleBox1 } from './params';
import { IArticle } from '../../../types/article';
import Styles from './styles';

import { IConfig } from '../../../types/config';
import { IContent } from '../../../types/elements';
import { common } from '../../../translates';
import TableOfContents from '../TableOfContents';

const EntireArticleBox: FC<{ config: IConfig; article: IArticle; language: string }> = ({
  config,
  article,
  language,
}) => {
  const cdnUrl = process.env.GATSBY_CDN_URL;
  const imageSrc = `${cdnUrl}/f-${article.imagePath}`;

  const isElement = (node: DOMNode): node is Element => {
    return (node as Element).type === 'tag';
  };

  const imgAddLazyLoad = (node: DOMNode): JSX.Element | undefined => {
    if (isElement(node) && node.name === 'img') {
      return <img {...node.attribs} alt={node.attribs.alt || ''} loading="lazy" />;
    }
    // default behavior for other nodes
    return undefined;
  };

  return (
    <Styles
      $config={config.article.entireArticleBox.params as IEntireArticleBox1}
      $global={config.general.content as IContent}
    >
      <div className="article-wrapper">
        {article.sponsored ? <p className="article-sponsored">{common[language].labelArticleSponsored}</p> : null}
        <h1>{article.name}</h1>
        <div className="article-image">
          <img src={imageSrc} alt={article.name} />
        </div>
        <div>
          <TableOfContents config={config.general} data={article.tableOfContents} language={language} />
          {parse(article.description, { replace: imgAddLazyLoad })}
        </div>
      </div>
    </Styles>
  );
};

export default EntireArticleBox;
